import { atom } from "jotai";

export const isInfiniteScrollContentAtom = atom<boolean>(false);
